import React, { useState } from 'react'


import Header from './Header';
import Filter from './Filter';
import CardView from './Card';
import Footer from './Footer';
import FormDialog from './Dialouge';
import { SettingsEthernetRounded } from '@mui/icons-material';



const Dashboard = () => {

  const [upload, setUpload] = useState(false);
  const [genre, setGenre] = useState("All");
  const [age, setAge] = useState("Any");
  const [sort, setSort] = useState(false);
  const [search, setSearch] = useState("");
  console.log(search);
  return (
    <div>
      <Header handleUpload={() => setUpload(!upload)} performSearch={(value)=>setSearch(value)} />
      <FormDialog value={upload} handleUpload={() => setUpload(!upload)}  />
      <Filter handleSort={()=> setSort(!sort)} handleGenre={(value) => setGenre(value)} handleAge={(value) => setAge(value)} filterGenre={genre} filterAge={age}/>
      <CardView filterSort={sort} filterGenre={genre} filterAge={age} searchCard={search} />
      <Footer />

    </div>
  )
}

export default Dashboard